import {
  type PartnerSaleRowDto,
  type PartnerSalesDto,
  type PartnerSalesKpiDto,
  type PartnerSalesPeriodDto,
  type PartnerSalesPeriodEnum,
  type PartnerSaleStatusEnum,
  type PartnerStudioDto,
  type TemplateLicenseTypeEnum,
} from '@lite-workspace/dto-design-system';

// The cabinet reads exactly what the server sends: these are `partner-studio.dto.ts` projected readonly,
// never a parallel declaration. The wire enums are kept as their plain string unions — the screens compare
// a cell against the very value they render, and a string enum member is assignable to that union.

export type PartnerStudio = Readonly<PartnerStudioDto>;

export type PartnerSalesPeriodId = `${PartnerSalesPeriodEnum}`;
export type PartnerSaleType = `${TemplateLicenseTypeEnum}`;
export type PartnerSaleStatus = `${PartnerSaleStatusEnum}`;

/** The server names the windows; the seed below repeats those four names verbatim. */
export type PartnerSalesPeriod = Readonly<Omit<PartnerSalesPeriodDto, 'id'>> & { readonly id: PartnerSalesPeriodId };

export type PartnerSalesKpi = Readonly<PartnerSalesKpiDto>;

export type PartnerSaleRow = Readonly<Omit<PartnerSaleRowDto, 'type' | 'status'>> & {
  readonly type: PartnerSaleType;
  readonly status: PartnerSaleStatus;
};

export type PartnerSales = Readonly<Omit<PartnerSalesDto, 'periods' | 'rows'>> & {
  readonly periods: readonly PartnerSalesPeriod[];
  readonly rows: readonly PartnerSaleRow[];
};

/** The four windows are fixed, so the chips stand in the FIRST frame instead of arriving with the sales. */
const PERIOD_CHIPS: readonly PartnerSalesPeriod[] = [
  { id: 'week', label: '7 дней' },
  { id: 'month', label: 'Месяц' },
  { id: 'quarter', label: 'Квартал' },
  { id: 'all', label: 'Всё время' },
];

export const EMPTY_PARTNER_SALES: PartnerSales = {
  periods: PERIOD_CHIPS,
  kpi: { revenueRub: 0, salesCount: 0, purchaseCount: 0, purchaseRub: 0, rentalCount: 0, rentalRub: 0, pendingCount: 0 },
  rows: [],
};
